module.exports = __webpack_public_path__ + "img/zs_icon_xx.924bb642.svg";